import React, { useState, useRef, useEffect } from 'react';
import './MobileTabBar.css';

/* ── Íconos SVG — idénticos al sidebar de escritorio (mismos paths, strokeWidth 1.8) ─── */
const icons = {
  sales: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="1" x2="12" y2="23"/>
      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
    </svg>
  ),
  orders: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
      <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
    </svg>
  ),
  resumen: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 2v20l3-2 3 2 3-2 3 2 3-2V2l-3 2-3-2-3 2-3-2-3 2z"/>
      <line x1="8" y1="9" x2="16" y2="9"/><line x1="8" y1="13" x2="16" y2="13"/>
      <line x1="8" y1="17" x2="12" y2="17"/>
    </svg>
  ),
  inventory: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="21 8 21 21 3 21 3 8"/>
      <rect x="1" y="3" width="22" height="5" rx="1"/>
      <line x1="10" y1="12" x2="14" y2="12"/>
    </svg>
  ),
  home: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/>
      <rect x="14" y="14" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/>
    </svg>
  ),
  catalog: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
      <polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/>
    </svg>
  ),
  customers: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
      <circle cx="9" cy="7" r="4"/>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
    </svg>
  ),
  trends: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
      <polyline points="17 6 23 6 23 12"/>
    </svg>
  ),
  marketing: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/>
      <path d="M15.54 8.46a5 5 0 0 1 0 7.07"/>
      <path d="M19.07 4.93a10 10 0 0 1 0 14.14"/>
    </svg>
  ),
  cashflow: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 7H5a2 2 0 0 0 0 4h14a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h14"/>
      <path d="M16 14h.01"/>
    </svg>
  ),
  costs: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 8V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2"/>
      <path d="M3 8h18v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8z"/>
      <path d="M8 12h8"/>
    </svg>
  ),
  settings: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3"/>
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
    </svg>
  ),
  users: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
      <circle cx="12" cy="7" r="4"/>
    </svg>
  ),
  logout: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
      <polyline points="16 17 21 12 16 7"/>
      <line x1="21" y1="12" x2="9" y2="12"/>
    </svg>
  ),
  finanzas: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="20" x2="18" y2="10"/>
      <line x1="12" y1="20" x2="12" y2="4"/>
      <line x1="6"  y1="20" x2="6"  y2="14"/>
      <line x1="2"  y1="20" x2="22" y2="20"/>
    </svg>
  ),
  more: (
    <svg viewBox="0 0 24 24" fill="currentColor" stroke="none">
      <circle cx="5"  cy="12" r="1.5"/>
      <circle cx="12" cy="12" r="1.5"/>
      <circle cx="19" cy="12" r="1.5"/>
    </svg>
  ),
};

// Caja: admin y coordinador. Costos: solo admin.
const VISIBLE_FOR_ROLE = {
  coordinador: new Set(['home', 'catalog', 'inventory', 'sales', 'orders', 'resumen', 'customers', 'cashflow']),
  // inicio-centro-control B2: el vendedor gana 'home' (Centro de control con sus 4 cuadros).
  vendedor:    new Set(['home', 'sales', 'orders', 'resumen', 'inventory', 'catalog']),
};

function canSee(id, role, isOwner, analiticaOn = false, agendaOn = false) {
  if (id === 'users')    return isOwner;
  if (id === 'settings') return role === 'admin' || isOwner;
  // F1-B1: Analítica es módulo opcional por tienda — sin flag no aparece, ni para admin.
  if (id === 'analitica') return analiticaOn && (role === 'admin' || isOwner);
  // AG-1: Agenda es módulo opcional por tienda — sin flag no aparece (admin/coordinador/owner).
  if (id === 'agenda') return agendaOn && (role === 'admin' || role === 'coordinador' || isOwner);
  if (role === 'admin')  return true;
  return (VISIBLE_FOR_ROLE[role] ?? VISIBLE_FOR_ROLE.vendedor).has(id);
}

/* Tabs principales (siempre en la barra si el rol tiene acceso) */
const PRIMARY_TABS = [
  { id: 'home',      label: 'Inicio',      icon: icons.home      },
  { id: 'sales',     label: 'Ventas',      icon: icons.sales     },
  { id: 'orders',    label: 'Pedidos',     icon: icons.orders    },
  { id: 'inventory', label: 'Inventario',  icon: icons.inventory },
];

/* Items del bottom sheet "Más" */
const MORE_ITEMS = [
  { id: 'resumen',   label: 'Resumen de ventas', icon: icons.resumen   },
  { id: 'catalog',   label: 'Catálogo',      icon: icons.catalog   },
  { id: 'cashflow',  label: 'Caja',          icon: icons.cashflow  },
  { id: 'finanzas',  label: 'Finanzas',      icon: icons.finanzas  },
  { id: 'costs',     label: 'Compras',       icon: icons.costs     },
  { id: 'customers', label: 'Clientes',      icon: icons.customers },
  { id: 'analitica', label: 'Analítica',     icon: icons.resumen   },
  { id: 'agenda',    label: 'Agenda',        icon: icons.resumen   },
  { id: 'settings',  label: 'Configuración', icon: icons.settings  },
  { id: 'users',     label: 'Usuarios',      icon: icons.users     },
];

export default function MobileTabBar({
  activePage,
  onNavigate,
  userRole = 'admin',
  isOwner = false,
  analiticaOn = false,
  agendaOn = false,
  badges = {},
  onLogout,
  scrollRef,
}) {
  const [sheetOpen, setSheetOpen] = useState(false);
  const [compact, setCompact] = useState(false);
  const navRef = useRef(null);
  const lastScrollTopRef = useRef(0);
  const throttleTimerRef = useRef(null);

  // iOS fix: cuando el teclado virtual se abre, el layout viewport no cambia pero el
  // visual viewport se encoge. Con position:fixed bottom:0, la tab bar queda detrás
  // del teclado y además iOS no siempre la repinta al cerrar el teclado.
  // Solución: escuchar visualViewport.resize y subir la tab bar sobre el teclado.
  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;

    // Solo hay teclado si un campo de texto está realmente enfocado. Atar el
    // transform a esto evita que cambios espurios del visualViewport (scroll,
    // barra de direcciones de Safari, rebote) muevan la tab bar fuera de pantalla.
    const isTypingTarget = () => {
      const a = document.activeElement;
      if (!a) return false;
      const tag = a.tagName;
      return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || a.isContentEditable;
    };

    const sync = () => {
      const el = navRef.current;
      if (!el) return;
      // Diferencia entre layout viewport y visual viewport = altura del teclado.
      const keyboardH = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
      // Levantar la barra SOLO si hay un input enfocado (teclado real) y el valor
      // está en rango sensato (250-350px típico; <150 = barra de Safari, no teclado).
      // Clamp a 500px para que jamás se empuje completamente fuera de vista.
      const lift = isTypingTarget() && keyboardH > 150
        ? Math.min(Math.round(keyboardH), 500)
        : 0;
      el.style.transform = lift > 0 ? `translateY(-${lift}px)` : '';
    };

    // Fallback: en iOS Safari PWA, vv.resize no siempre se dispara cuando el
    // teclado se cierra (bug conocido de WebKit). Al perder el foco cualquier
    // input, re-sincronizar en dos momentos: 250ms (animación inicial) y 600ms
    // (iOS puede tardar más en actualizar vv.height cuando se desmontan inputs).
    const onFocusOut = () => {
      setTimeout(sync, 250);
      setTimeout(sync, 600);
    };

    vv.addEventListener('resize', sync);
    window.addEventListener('focusout', onFocusOut);
    return () => {
      vv.removeEventListener('resize', sync);
      window.removeEventListener('focusout', onFocusOut);
    };
  }, []);

  // Compactar tab bar al scrollear hacia abajo; expandir al subir o en el tope
  useEffect(() => {
    const el = scrollRef?.current;
    if (!el) return;

    const handleScroll = () => {
      if (throttleTimerRef.current) return;
      throttleTimerRef.current = setTimeout(() => {
        throttleTimerRef.current = null;
        const st = el.scrollTop;
        const delta = st - lastScrollTopRef.current;
        if (st < 10) {
          setCompact(false);
        } else if (delta > 0) {
          setCompact(true);
        } else if (delta < -5) {
          setCompact(false);
        }
        lastScrollTopRef.current = st;
      }, 100);
    };

    el.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      el.removeEventListener('scroll', handleScroll);
      if (throttleTimerRef.current) {
        clearTimeout(throttleTimerRef.current);
        throttleTimerRef.current = null;
      }
    };
  }, [scrollRef]);

  // Volver a estado expandido al cambiar de página; limpiar transform residual del teclado
  useEffect(() => {
    setCompact(false);
    lastScrollTopRef.current = 0;
    if (navRef.current) navRef.current.style.transform = '';
  }, [activePage]);

  const visibleTabs = PRIMARY_TABS.filter(t => canSee(t.id, userRole, isOwner, analiticaOn, agendaOn));
  const moreItems   = MORE_ITEMS.filter(m => canSee(m.id, userRole, isOwner, analiticaOn, agendaOn));
  const showMore    = moreItems.length > 0;
  const moreActive  = moreItems.some(m => m.id === activePage);

  const handleTab = (id) => {
    try { navigator.vibrate?.(5); } catch (_) {}
    onNavigate(id);
  };

  const handleMoreItem = (id) => {
    try { navigator.vibrate?.(5); } catch (_) {}
    onNavigate(id);
    setSheetOpen(false);
  };

  const openSheet = () => {
    try { navigator.vibrate?.(5); } catch (_) {}
    setSheetOpen(true);
  };

  return (
    <>
      <nav ref={navRef} className={`mob-tabbar${compact ? ' mob-tabbar--compact' : ''}`} role="tablist" aria-label="Navegación principal">
        {visibleTabs.map((tab) => {
          const isActive = activePage === tab.id;
          const badge    = badges[tab.id] || 0;
          return (
            <button
              key={tab.id}
              role="tab"
              aria-selected={isActive}
              className={`mob-tab${isActive ? ' mob-tab--active' : ''}`}
              onClick={() => handleTab(tab.id)}
              aria-label={tab.label}
            >
              <span className="mob-tab-icon-wrap">
                <span className="mob-tab-icon">{tab.icon}</span>
              </span>
              <span className="mob-tab-label">{tab.label}</span>
              {badge > 0 && (
                <span className="mob-tab-badge">{badge > 9 ? '9+' : badge}</span>
              )}
            </button>
          );
        })}

        {showMore && (
          <button
            role="tab"
            aria-selected={moreActive}
            className={`mob-tab${moreActive ? ' mob-tab--active' : ''}`}
            onClick={openSheet}
            aria-label="Más módulos"
          >
            <span className="mob-tab-icon-wrap">
              <span className="mob-tab-icon">{icons.more}</span>
            </span>
            <span className="mob-tab-label">Más</span>
          </button>
        )}
      </nav>

      {/* Bottom sheet "Más" */}
      {sheetOpen && (
        <div
          className="mob-sheet-overlay"
          onClick={() => setSheetOpen(false)}
          role="dialog"
          aria-modal="true"
          aria-label="Más módulos"
        >
          <div className="mob-sheet" onClick={(e) => e.stopPropagation()}>
            <div className="mob-sheet-handle" aria-hidden="true" />
            <div className="mob-sheet-title">Módulos</div>
            <div className="mob-sheet-items">
              {moreItems.map((item) => (
                <button
                  key={item.id}
                  className={`mob-sheet-item${activePage === item.id ? ' mob-sheet-item--active' : ''}`}
                  onClick={() => handleMoreItem(item.id)}
                >
                  <span className="mob-sheet-item-icon">{item.icon}</span>
                  <span className="mob-sheet-item-label">{item.label}</span>
                  {activePage === item.id && (
                    <span className="mob-sheet-item-check" aria-hidden="true">✓</span>
                  )}
                </button>
              ))}
              <button
                className="mob-sheet-item mob-sheet-item--logout"
                onClick={() => { setSheetOpen(false); onLogout?.(); }}
              >
                <span className="mob-sheet-item-icon mob-sheet-item-icon--logout">
                  {icons.logout}
                </span>
                <span className="mob-sheet-item-label">Cerrar sesión</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
